import React from 'react';
import { NavLink } from 'react-router-dom';
import { IoMdCart } from "react-icons/io";
import { Badge } from 'react-bootstrap';
import ShopHOC from '../../../../hoc/ShopHOC';
import { useTranslation } from 'react-i18next';

function MiniCart(props) {
    const { t } = useTranslation();
    const { cartProductsCount, url, handleCartOpen, cartOrder } = props;

    const handleNavClick = (e) => {
        if (!cartOrder.orderRows.length) {
            e.preventDefault()
        }
    }
    
    return (
        <div>
            <button className="shoppingCartNav" onClick={() => handleCartOpen(true)}>
                <IoMdCart style={{marginTop:-3}}/>
                &nbsp;{t('events.cart')}&nbsp;
                <div className="badgeContainer">
                    <Badge pill variant="danger">
                        {cartProductsCount ? (cartProductsCount <= 10 ? cartProductsCount : 10) : 0}
                    </Badge>
                </div>
            </button>
            <NavLink
                activeClassName='active'
                style={{cursor: !cartOrder.orderRows.length ? 'no-drop' : 'pointer', textDecoration:'none'}}
                onClick={(e) => handleNavClick(e)}
                to={`${url}/checkout`}
                // isActive={() => {return false}}
            >
                {t('events.checkout')}
            </NavLink>
        </div>
    )
}

export default ShopHOC(MiniCart);